





































import { brandContext } from '@/constants/locales';
import { Component, Vue, Prop } from 'vue-property-decorator';

const isUrlAbsolute = (url: string) => url.indexOf('://') > 0 || url.indexOf('//') === 0;

@Component
export default class Dealer extends Vue {
  @Prop() dealerAddress?: string;
  @Prop() dealerLink?: string;
  @Prop() market?: string;

  locale(translationKey: string) {
    return this.$t(`dealer.${translationKey}`);
  }

  get brandContext() {
    return brandContext;
  }

  get absoluteDealerLink() {
    if (this.dealerLink) {
      return isUrlAbsolute(this.dealerLink) ? this.dealerLink : `https://${this.dealerLink}`;
    }
    return '';
  }
}
